import styled from 'styled-components';

const Grid = styled.div`
  position: relative;
  overflow-y: initial;
  display: flex;
  flex-direction: column;
  margin: 0;

  ${Styles.desktop`
    margin: 0 20%;
  `}
`;

export default Grid;
